// extracted by mini-css-extract-plugin
module.exports = {"middle_panel_list":"SettingsMiddlePanel_middle_panel_list__2mr4K","middle_panel_list_0":"SettingsMiddlePanel_middle_panel_list_0__30p_s"};